/**
 * Catalog expiry: `listedAt` (ms) + `validityMonths` → `expiresAtMs`.
 * Uses calendar months via Date#setMonth.
 */

export function parseValidityMonths(raw) {
  const n = Number(raw?.validityMonths ?? raw?.ValidityMonths ?? 0);
  if (n > 0) return Math.min(1200, Math.floor(n));
  const legacy = String(raw?.Validity ?? raw?.validity ?? "").trim();
  if (/^\d+$/.test(legacy)) {
    const m = Number(legacy);
    if (m > 0) return Math.min(1200, Math.floor(m));
  }
  return 0;
}

export function parseListedAtMs(raw) {
  const v =
    raw?.listedAt ??
    raw?.listed_at ??
    raw?.createdAt ??
    raw?.catalogListedAt ??
    raw?.listedAtMs;
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export function computeExpiresAtMs(listedAtMs, validityMonths) {
  if (!listedAtMs || !validityMonths || validityMonths <= 0) return null;
  const d = new Date(listedAtMs);
  d.setMonth(d.getMonth() + validityMonths);
  return d.getTime();
}

export function formatExpiryDate(expiresAtMs) {
  if (!expiresAtMs) return "";
  try {
    return new Intl.DateTimeFormat(undefined, {
      dateStyle: "medium",
    }).format(new Date(expiresAtMs));
  } catch {
    return new Date(expiresAtMs).toLocaleDateString();
  }
}

export function isExpired(expiresAtMs) {
  if (expiresAtMs == null) return false;
  return Date.now() > expiresAtMs;
}
